import script from "./PlusSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./PlusSurvey.vue?vue&type=script&setup=true&lang=js"

import "./PlusSurvey.vue?vue&type=style&index=0&id=378850bb&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378850bb"]])

export default __exports__